'use client';

import { useEffect, useState } from 'react';
import { useConfigure } from 'react-instantsearch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fr } from 'date-fns/locale/fr';

export default function DateRangeFilter() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  let filters: string | undefined;
  if (startDate) {
    const startFormatted =
      startDate.getFullYear().toString() +
      ('0' + (startDate.getMonth() + 1)).slice(-2) +
      ('0' + startDate.getDate()).slice(-2);
    filters = `date_start_formatted >= ${startFormatted}`;
  }
  if (endDate) {
    const endFormatted =
      endDate.getFullYear().toString() +
      ('0' + (endDate.getMonth() + 1)).slice(-2) +
      ('0' + endDate.getDate()).slice(-2);
    filters = filters
      ? `${filters} AND date_end_formatted <= ${endFormatted}`
      : `date_end_formatted <= ${endFormatted}`;
  }

  // @ts-ignore
  useConfigure({ filters: filters });

  const resetDates = () => {
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-full bg-gray-100 px-4 py-[6px]">
      <span className="mr-2 font-medium">Dates:</span>
      <div className="flex items-center gap-2">
        <DatePicker
          selected={startDate}
          onChange={setStartDate}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          placeholderText="Date de début"
          className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          dateFormat="dd/MM/yyyy"
          locale={fr}
        />
        <span>-</span>
        <DatePicker
          selected={endDate}
          onChange={setEndDate}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate || undefined}
          placeholderText="Date de fin"
          className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          dateFormat="dd/MM/yyyy"
          locale={fr}
        />
        {(startDate || endDate) && (
          <button
            className="ml-2 rounded-full bg-gray-200 p-1 hover:bg-gray-300"
            onClick={resetDates}
            aria-label="Réinitialiser"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
